import React from 'react';
import { t } from '../../../services/i18nService';

import fileDeliveryService from '../../../services/FileDeliveryService';
import styles from '../options.scss';

const FileDeliveryLink = () => {
    const fileContents = fileDeliveryService.getEncryptedFileContent(false);

    return (
        <a
            className={styles.optionItem}
            download={fileDeliveryService.getFileName()}
            href={fileDeliveryService.getFileBlobForLink(fileContents)}
        >
            <i className="fa fa-fw fa-floppy-o" aria-hidden="true" />
            <span>{t('options.fileDelivery')}</span>
        </a>
    );
};

export default FileDeliveryLink;
